import React from 'react';
import { LinearProgress } from '@material-ui/core';

export default function SplashScreen() {
  return <LinearProgress />;
}
